import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Button.css";

class Button extends Component {
  day = this.props.day !== undefined ? `/${this.props.day}` : "";
  path = this.props.path !== undefined ? this.props.path : "";

  render() {
    return (
      <div className="button-class-wrapper">
        <Link className="button-class" to={`/${this.path}${this.day}`}>
          {this.props.buttonValue}
        </Link>
      </div>
    );
  }
}

export default Button;
